import React, { useContext, useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getAddress } from "http/address/address"
import ToastDialog from "components/Common/ToastDialog"
import { CartContext } from "context/cartContext"
import { addOrder } from "http/order/order"
import { emptyCart } from "http/cart/cart"
import { SystemConfigurationContext } from "context/systemConfigContext"
import FullPageLoader from "components/Common/FullPageLoader"
import Select from "react-select";
import { getShipToPartyList } from "helpers/UAM/dealer.helper"

const AddressSelection = () => {
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [addressData, setAddressData] = useState([])
  const [responseData, setResponseData] = useState(null)
  const [toastInfo, setToastInfo] = useState({ showToast: false })
  const { cartItems, getCartData } = useContext(CartContext);
  const [poDate, setPoDate] = useState(null);
  const [poNumber, setPoNumber] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [shipToParty, setShipToParty] = useState(null);
  const [shipToPartyList, setShipToPartyList] = useState([]);
  const navigate = useNavigate()
  const { inputMax } = useContext(SystemConfigurationContext)

  const handleAddressSelection = address => {
    setSelectedAddress(address.id === selectedAddress ? null : address.id)
  }
  const { entityId, id } = JSON.parse(localStorage.getItem("user"))

  useEffect(() => {
    if (cartItems.length == 0) {
      navigate('/customer/listProduct')
    }

    fetchAddress()
    fetchShipToPartyList()
  }, [])
  const fetchAddress = async () => {
    try {
      let res = await getAddress({ entityId: entityId })
      if (!res.status) {
        throw new Error("No Address is found")
      }

      let sortedData = res.data.data.sort((a, b) => a.id - b.id)
      if (sortedData.length == 1) {
        setSelectedAddress(sortedData[0].id)
      }

      setAddressData(sortedData)

    } catch (e) {
      setToastInfo({
        message: e.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const products = cartItems.map(
    i =>
    ({
      productId: i.product.id,
      quantity: i.quantity,
      price: i.product.sellingPrice,
    } || [])
  )

  const handlePlaceOrder = async () => {
    try {
      // if (!selectedAddress) {
      //   throw new Error("Address is not selected")
      // }
      let order = {
        dealerId: entityId,
        dealerUserId: id,
        address: selectedAddress || "",
        products: products,
        shipToParty: shipToParty,
        poNumber,
        poDate,
      }
      setIsLoading(true)
      let res = await addOrder(order)
      const { status, message, data } = res
      if (!status) {
        setIsLoading(false)
        throw new Error("Something went wrong")
      }
      setResponseData(data)
      setIsLoading(false)
      setToastInfo({
        message: message,
        showToast: true,
        role: "success",
      })
      let res1 = await emptyCart()
      if (res1.status) {
        getCartData()
      }
      setSelectedAddress(null)
    } catch (err) {
      setToastInfo({
        message: err.message,
        showToast: true,
        role: "error",
      })
    }
  }

  const fetchShipToPartyList = async () => {
    try {
      let res = await getShipToPartyList()
      if (!res.status) {
        setShipToPartyList([])
      }
      setShipToPartyList(res?.data || [])
    } catch (e) {
        setShipToPartyList([])
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isLoading && <FullPageLoader />}
          {
            !responseData ? (
              <>
                <Breadcrumbs title="Ecommerce" breadcrumbItem="Place Order" />
                <div className="d-flex">
                <Card className="w-100">
                  <CardBody>
                    <Row>
                      <Col md={6}>
                        <div className="d-flex flex-column h-100">
                        <h5>Select Delivery Address</h5>
                        <Label for="address">Address:</Label>
                        <div className="h-100">
                          <Card className="address-card-w">
                            <div className="form-inner-address">
                              {addressData.map(address => (
                                <div
                                  style={{ margin: "5px" }}
                                  key={address.id}
                                  className={`${selectedAddress === address.id ? "selected" : ""
                                    }`}
                                  id="address-card"
                                  onClick={() => handleAddressSelection(address)}

                                >
                                  <CardBody>
                                    <Label style={{ display: 'flex', flexDirection: 'row' }} role='button'>
                                      <Input
                                        type="radio"
                                        name="address"
                                        checked={selectedAddress === address.id}
                                        style={{ marginRight: "10px", border: '1px solid #b8b8bb', padding: '5px' }}
                                        onChange={() => { }}
                                      />{" "}
                                      <span>
                                        {`${address.address1 ? address.address1 : ''} ${address.address2 ? address.address2 : ''} ${address.address3 ? address.address3 : ''}, ${address.city ? address.city : ''}, ${address.state ? address.state : ''}, ${address.pincode ? address.pincode : ''}`}
                                      </span>
                                    </Label>
                                  </CardBody>
                                </div>
                              ))}
                                  {addressData.length === 0 && (
                                    <div
                                      className="text-center font-size-16 d-flex align-items-center justify-content-center"
                                      style={{
                                        height: '50px'
                                      }}
                                    >
                                      No Address found
                                    </div>
                                  )}
                            </div>
                          </Card>
                        </div>
                        </div>
                      </Col>
                      <Col md={6} className="mt-4 mt-md-0">
                        <Row className="mb-3">
                          <h5>PO Details</h5>
                          <Col md={6}>
                            <Label for="poNumber">PO Number:</Label>
                            <Input
                              maxLength={inputMax}
                              type="text"
                              id="poNumber"
                              value={poNumber}
                              onChange={(e) => setPoNumber(e.target.value)}
                            />
                          </Col>
                          <Col md={6} className="mt-2 mt-md-0">
                            <Label for="poDate">PO Date:</Label>
                            <Input
                              type="date"
                              id="poDate"
                              value={poDate}
                              onChange={(e) => setPoDate(e.target.value)}
                            />
                          </Col>
                            <Col md={6}>
                              <Label className="form-label mt-3">Select Ship to Party
                              </Label>
                              <Select
                                options={shipToPartyList.map((option) => ({
                                  label: option.partnerCode + ' ' + `(${option.address})`,
                                  value: option.partnerCode,
                                }))}
                                className={`select-dropdown select2-selection`}
                                name="ship_to_party"
                                id="ship_to_party"
                                onChange={(selectedOption) => {
                                  setShipToParty(selectedOption.value)
                                }}
                              />
                            </Col>
                        </Row>
                        <div className="d-flex flex-column justify-content-center align-items-center">
                          <div style={{ flexDirection: "row", display: "flex", marginLeft: "auto", paddingTop: "5px", paddingBottom: '10px' }}>
                            <Link to="/customer/cart" className={`btn btn-outline-secondary me-2 ${isLoading ? 'disabled' : ''}`}>
                              <i className="mdi mdi-arrow-left me-1 " /> Back to Cart
                            </Link>
                            {<Button onClick={handlePlaceOrder} color="success">
                              Place Order Request <i className="mdi mdi-cart-arrow-right ms-1" />
                            </Button>}
                          </div>
                          <img
                            style={{
                              width: "52%",
                            }}
                            src="/place-order.svg"
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: "flex-end",
                            gap: "1rem",
                            marginTop: "2rem",
                          }}
                        >
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                </div>
              
              </>
            ) : (
              <div style={{ textAlign: "center", marginTop: "24px" }}>
                <i className="bx bx-check-circle text-success mb-2" style={{ fontSize: '48px' }} />
                  <h4 className="fw-bold text-black ">Congratulations!</h4>
                {/* <p className="pt-3">Order Request Number: #{responseData.orderCode}</p> */}
                <p className="pt-1 text-black-50 fw-medium">
                  Your order request has been successfully placed.
                  </p>
                <div>
                  <a
                    href="/customer/order-request"
                    className="px-4 text-success fw-medium"
                  >
                    View Order Request
                  </a>
                </div>
                <img
                  src="/order-placed.svg"
                  alt="Empty Cart"
                  style={{ width: "300px", height: "200px" }}
                />
                <p>
                  <a
                      href="/customer/listProduct"
                    className="btn btn-success px-5"
                  >
                    Continue Shopping
                  </a>
                </p>
              </div>
            )
          }

        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      />
    </React.Fragment>
  )
}

export default AddressSelection
